import { Container } from "react-bootstrap";
import hologrambanner from "../assets/img/inner-banner/Hologram-Security.webp";
import hologrambannerBanner from "../assets/img/mobile-banner/Hologram-Security.webp";

import "./ServiceDetails.css";
import { Link } from "react-router-dom";
import {
  MdKeyboardDoubleArrowRight,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";
import AntiCounterfeit from "../assets/img/hologram-images/Anti-Counterfeit-Security.webp";
import Verification from "../assets/img/hologram-images/Instant-Verification.webp";
import Tamper from "../assets/img/hologram-images/Tamper-Evident-Protection.webp";

import Premium from "../assets/img/hologram-images/Premium-Presentation.webp";

import sealing from "../assets/img/SEALING-SERVICES.jpg";
import online from "../assets/img/SERVICES.jpg";
import { Helmet } from "react-helmet";

export default function Hologram() {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>
          Best Hologram Stickers for Diamond Certificates | Sreehari Diamond
          Laboratory{" "}
        </title>
        <meta
          name="description"
          content="Our premium hologram stickers are designed to safeguard your diamond grading reports, authenticity certificates, and packaging from duplication or tampering."
        />
        <meta
          name="keywords"
          content="lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Diamond Hologram Stickers, Hologram Stickers for Certificates, Best diamond online services"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="Best Hologram Stickers for Diamond Certificates | Sreehari Diamond Laboratory"
        />
        <meta
          property="og:description"
          content="Our premium hologram stickers are designed to safeguard your diamond grading reports, authenticity certificates, and packaging from duplication or tampering."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://sreeharidiamondlab.com/diamond-hologram-stickers"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/Instant-Verification.d173b5672daffc3c3a5d.webp"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Best Hologram Stickers for Diamond Certificates | Sreehari Diamond Laboratory"
        />
        <meta
          name="twitter:description"
          content="Our premium hologram stickers are designed to safeguard your diamond grading reports, authenticity certificates, and packaging from duplication or tampering."
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/Instant-Verification.d173b5672daffc3c3a5d.webp"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/diamond-hologram-stickers"
        />{" "}
      </Helmet>
      <section>
        <Container fluid className="bannersection position-relative p-0">
          <img
            src={
              window.innerWidth > 568 ? hologrambanner : hologrambannerBanner
            }
            alt="Service banner"
            className="w-100  h-100 object-fit-cover about-banner-img"
          />
        </Container>
      </section>
      <section className="hologram-section section-spacing-x section-spacing-y pb-0">
        <div className="container-fluid">
          <div className="row">
            <h1 className="heading mb-3 text-center">
              Diamond Hologram Security Stickers{" "}
            </h1>
          </div>
          <p>
            Protect your valuable diamonds with advanced hologram security
            solutions for certificates. Holographic stickers provide
            tamper-proof, counterfeit-resistant authentication, ensuring the
            diamond's origin, grading, and ownership are securely verified.
            These high-tech labels use 3D optical elements, QR codes, and serial
            numbers, offering unmatched transparency in the diamond supply
            chain. Ideal for jewelers, manufacturers, and certification labs,
            hologram security builds trust and enhances brand integrity. Secure
            your diamonds against forgery and fraud with cutting-edge hologram
            technology. Ensure every gem is authentic, traceable, and protected.
            Upgrade your diamond authentication process today with premium
            hologram security for diamonds and safeguard your investment.{" "}
          </p>
          <div className="contact-us-button mt-lg-4 mb-lg-5 mb-4">
            <Link to="/contact-us">
              Contact Us <MdOutlineKeyboardDoubleArrowRight />
            </Link>
          </div>

          <div className="row mb-lg-4 mb-2">
            <div className="col-md-6 col-lg-6 col-xl-3 mb-4 mb-xl-0">
              <div className="benifit-card">
                <div className="position-relative">
                  <img
                    src={AntiCounterfeit}
                    className="img-fluid w-100"
                    alt="Anti Counterfeit Security | Sreehari Diamond Laboratory"
                  />
                  <h5>Anti-Counterfeit Security</h5>
                </div>
                <div className="content">
                  <p>
                    Advanced holographic technology makes these stickers nearly
                    impossible to replicate, protecting your diamond reports
                    from forgery.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3 mb-4 mb-xl-0">
              <div className="benifit-card">
                <div className="position-relative">
                  <img
                    src={Verification}
                    className="img-fluid w-100"
                    alt="Instant Verification | Sreehari Diamond Laboratory"
                  />
                  <h5>Instant Verification</h5>
                </div>
                <div className="content">
                  <p>
                    Clients can visually recognize a genuine diamond certificate
                    at a glance, ensuring confidence in your lab's grading.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3 mb-4 mb-xl-0">
              <div className="benifit-card">
                <div className="position-relative">
                  <img
                    src={Tamper}
                    className="img-fluid w-100"
                    alt="Tamper Evident Protection | Sreehari Diamond Laboratory"
                  />
                  <h5>Tamper-Evident Protection </h5>
                </div>
                <div className="content">
                  <p>
                    If removed, the hologram sticker shows visible damage -
                    preventing it from being reused on fake certificates.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3 mb-4 mb-xl-0">
              <div className="benifit-card">
                <div className="position-relative">
                  <img
                    src={Premium}
                    className="img-fluid w-100"
                    alt="Premium Presentations | Sreehari Diamond Laboratory"
                  />
                  <h5>Premium Presentation</h5>
                </div>
                <div className="content">
                  <p>
                    Advanced holographic technology makes these stickers nearly
                    impossible to replicate, protecting your diamond reports
                    from forgery.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-spacing-x">
        <div className="container-fluid">
          <div className="row mb-5">
            <h2 className="text-center mb-4 heading">Other Services</h2>
            <div className="col-lg-4 mb-lg-0 mb-3">
              <div className="service-card text-center border rounded p-2 ">
                <div className="service-image mx-auto">
                  <img src={sealing} alt="service" className="img-fluid" />
                </div>
                <Link to={"/diamond-sealing-service"}>
                  <h3 className="mt-0">Sealing Service</h3>
                </Link>
                <p className="mt-0">
                  Our Sealing Service ensures your diamonds are protected in
                  tamper - proof holders, preserving authenticity and value.{" "}
                </p>
                <div className="service-read-more mb-3">
                  <Link to={"/diamond-sealing-service"}>
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-card text-center border rounded p-2">
                <div className="service-image mx-auto">
                  <img src={online} alt="service" className="img-fluid" />
                </div>
                <Link to="/online-certificate-verification">
                  <h3 className="mt-0">Online Service</h3>
                </Link>

                <p className="mt-0">
                  With our Online Service, you can easily submit your gemstones
                  remotely and receive detailed grading reports without visiting
                  the lab.{" "}
                </p>
                <div className="service-read-more mb-3">
                  <Link to="/online-certificate-verification">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
